<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      align-center
      justify-center
    >
      <v-flex
        xs12
        sm8
        md4
      >
        <v-card class="elevation-12">
          <v-toolbar
            dark
            color="accent"
          >
            <v-toolbar-title>Administrator Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-text-field
                prepend-icon="person"
                v-model="emailAddress"
                label="Email address"
                type="email"
                required
                :rules="emailRules"
              ></v-text-field>
              <v-text-field
                id="password"
                v-model="password"
                prepend-icon="lock"
                name="password"
                label="Password"
                type="password"
                required
                :rules="passwordRules"
              ></v-text-field>
              <span class="error--text">{{apiMessage}}</span>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              @click="getAdminToken"
            >Log In</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AdminLogin",
  data() {
    return {
      valid: false,
      emailAddress: "",
      password: "",
      emailRules: [v => !!v || "Email required",
        v => /.+@.+/.test(v) || 'Email must be valid'],
      passwordRules: [v => !!v || "Password is required"]
    };
  },
  computed: {
    ...mapState("admin", {
      token: state => state.token,
      apiMessage: state => state.apiMessage
    })
  },
  methods: {
    getAdminToken() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("admin/logIn", {
            username: this.emailAddress,
            password: this.password
          })
          .catch(e => alert("Bummer, we failed to log you in... " + e.message));
      }
    }
  },
  watch: {
    token() {
      this.$router.push({
        name: "ChooseHostMode"
      });
    }
  }
};
</script>